// extracted by mini-css-extract-plugin
export default {"container":"spinner_container__W4h2v","body":"spinner_body__jWd4I"};